import { onMobileDevice } from '../globalStyle/mediaQueries';
import { css } from '@emotion/core';
import { COLORS } from '../globalStyle/colors';


/**
 * The standard, responsive page padding
 */
export const PAGE_PADDING = css`
  padding: 60px 50px;
  
  ${onMobileDevice} {
    padding: 48px 0 0;
  }
`;


/**
 * Page should fill viewport height at a minimum
 */
export const PAGE_HEIGHT = css`
  min-height: 100vh;
`;


/**
 * Page should have a fabulous background color
 */
export const PAGE_BG = css`
  background-color: ${COLORS.PAGE_BG};
`;
